{
  "name": "revbot.js",
  "version": "0.2.4",
  "description": "A Revolt bot client used to interact with the revolt api for Node.js, written in TypeScript.",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "files": [
    "dist"
  ],
  "engines": {
    "node": ">=21.0.0"
  },
  "repository": "https://github.com/Jade3375/revbot.js",
  "keywords": [
    "revoltjs",
    "revolt.js",
    "bot",
    "client",
    "revbot",
    "typescript"
  ],
  "homepage": "https://jade3375.github.io/revbot.js/",
  "author": "Jade3375",
  "license": "MIT",
  "packageManager": "yarn@4.9.1",
  "devDependencies": {
    "@mxssfd/typedoc-theme": "^1.1.7",
    "@types/node": "^22.15.2",
    "@types/ws": "^8.18.1",
    "eslint-config-prettier": "^10.1.2",
    "prettier": "^3.5.3",
    "rimraf": "^6.0.1",
    "tsup": "^8.4.0",
    "typedoc": "^0.28.3",
    "typedoc-plugin-extras": "^4.0.0",
    "typedoc-plugin-mdn-links": "^5.0.1",
    "typedoc-plugin-merge-modules": "^7.0.0",
    "typescript": "^5.8.3"
  },
  "dependencies": {
    "axios": "^1.12.2",
    "form-data": "^4.0.2",
    "revolt-api": "^0.8.6-1",
    "ws": "^8.18.1"
  },
  "scripts": {
    "lint": "eslint . --ext .ts --fix",
    "build": "yarn clean && yarn tsup ./src/index.ts --format cjs,esm --clean --dts --sourcemap",
    "start": "yarn build && yarn node --enable-source-maps dist/index.js",
    "testClient": "yarn test:build && yarn node --enable-source-maps dist/test.js",
    "clean": "rimraf dist",
    "test:docs": "rimraf docs && yarn typedoc --options static/typedoc.json",
    "test:build": "yarn clean && tsc -p tsconfig.json",
    "publish": "yarn build && npm publish"
  }
}
